<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="新增版本"
      width="500"
      :open="open"
      @close="close"
      class="create-dialog"
    >
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="v" label="版本">
          <mu-text-field v-model="form.v"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="url" label="下载链接">
          <mu-text-field v-model="form.url"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        versiov: '',
        url: ''
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.release.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                v: '',

                url: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="less" scoped>
.create-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/release/create.vue